export function getInitCondition(officeId) {
  return {
    table: 'inspection_reports',
    column: 'inspector_office_id',
    comp: '=',
    field: [officeId],
  }
}
